<!--............Start Navbar..............-->
<nav *ngIf="(bottomBarService.showNavBar$ | async) && userHasProfile && !isNiagaIAView">
    <div class="container nav-container">
        <div style="display: flex;">
            <div class="logo-container">
                <div class="text-container">
                    <div class="text">
                        <span><img src="https://firebasestorage.googleapis.com/v0/b/lenalikoura.firebasestorage.app/o/images%2Fniaga%20logo.png?alt=media&token=9a1620ea-5fab-423d-a166-f163986c16b2" style="width: 40px; height: 40px;"></span>
                    </div>
                </div>
            </div>
            <h3 class="mt-2 lenali">Niaga</h3>
        </div>
        
        <!-- Barre de recherche -->


        <div class="search-bar">
            <i *ngIf="searchQuery.trim().length <= 0" class="fa fa-search"> </i>
            <input type="text" 
                   [(ngModel)]="searchQuery" 
                   (input)="onSearchChange($event.target.value)"
                   (keyup.enter)="performSearch()"
                   [placeholder]="'COMMON.SEARCH' | translate"
                   #searchInput>
            <button *ngIf="searchQuery.trim().length > 0" 
                #searchButton
                class="search-button" 
                (click)="performSearch()">
                <i class="fa fa-search"></i>
            </button>
        
            <!-- Liste des suggestions avec gestion du clic en dehors -->
            <div class="search-suggestions" 
                 *ngIf="showSuggestions" 
                 (clickOutside)="onClickOutside($event)"
                 [exclude]="searchInput ? [searchInput] : []">
                <ul>
                    <li *ngFor="let suggestion of searchSuggestions" 
                        (click)="selectSuggestion(suggestion)"
                        class="suggestion-item"
                        [class.user-suggestion]="suggestion.type === 'user'"
                        [class.post-suggestion]="suggestion.type === 'post'">
                        
                        <!-- Suggestion d'utilisateur -->
                        <ng-container *ngIf="suggestion.type === 'user'">
                           
                            <img [src]="suggestion.data.photoURL || 'assets/default-profile.png'" 
                                 class="suggestion-avatar" 
                                 alt="Profile photo">
                            <div class="suggestion-details">
                                <span class="suggestion-name">{{ suggestion.text }}</span>
                                <span class="suggestion-info" *ngIf="suggestion.data.ville">{{ suggestion.data.ville }}</span>
                            </div>
                        </ng-container>

                        <!-- Suggestion de post -->
                        <ng-container *ngIf="suggestion.type === 'post'">
                            <i class="fa fa-search"></i>
                            <div class="suggestion-details">
                                <span class="suggestion-text" [innerHTML]="highlightSearchTerm(suggestion.text, suggestion.data.searchTerm)"></span>
                                <span class="suggestion-preview" *ngIf="suggestion.data.preview">
                                    {{ suggestion.data.preview.substring(0, 90) }}...
                                </span>
                            </div>
                        </ng-container>
                    </li>
                </ul>
            </div>
        </div>
        
        <div class="profile-menu">
            <div class="notif-container">
                <app-notifications></app-notifications>
            </div>
        
            <!-- Menu profil avec options -->
            <div class="profile-options">
                <div class="profile-picture ml-4" id="my-profile-picture" (click)="toggleProfileMenu()">
                    <img [src]="profilePhotoUrl" alt="" [matMenuTriggerFor]="menu">
                </div>
                <mat-menu #menu="matMenu">
                    <button mat-menu-item [routerLink]="['/postfeed/userprofile', currentUser.uid]" routerLinkActive="active">{{ 'NAV.MY_PROFILE' | translate }}</button>
                    <button mat-menu-item routerLink="settings" routerLinkActive="active">
                        <span>{{ 'NAV.SETTINGS' | translate }}</span>
                    </button>
                    <button mat-menu-item (click)="onLogoutClick()">{{ 'NAV.LOGOUT' | translate }}</button>
                </mat-menu>
            </div>
        </div>
    </div>
</nav>

<main class="background" *ngIf="userHasProfile">
    <div class="container main-container" [class.bottom-bar-hidden]="!isBottomBarVisible">
        <!--==============Main Left Start==============-->
        <div class="main-left" *ngIf="!isMobileView">
            <ng-container *ngIf="isProfileView || isMessagesView">
                <div class="back-button-container">
                    <button class="back-button" (click)="goBack()">
                        <mat-icon>arrow_back</mat-icon>
                        <span>Retour</span>
                    </button>
                </div>
            </ng-container>

            <ng-container *ngIf="!isProfileView && !isMessagesView">
                <div class="profile" [routerLink]="['/postfeed/userprofile', currentUser.uid]" routerLinkActive="active">
                    <div class="profile-picture-2" id="my-profile-picture">
                        <img [src]="profilePhotoUrl ? profilePhotoUrl : 'assets/default-profile.png'" alt="">
                    </div>
                    <div *ngIf="currentUser" class="profile-handle">
                        <h5>{{currentUser.publicName}}</h5>
                        <p class="text-gry">{{currentUser.description}}, {{currentUser.ville}}</p>
                    </div>
                    <div class="user-stats">
                        <div class="stat-item">
                            <div class="stat-value">{{currentUser?.followers?.length || 0}}</div>
                            <div class="stat-label">Suiveurs</div>
                        </div>
                        <div class="stat-item">
                            <div class="stat-value">{{currentUser?.following?.length || 0}}</div>
                            <div class="stat-label">Suivi(e)</div>
                        </div>
                        <div class="stat-item">
                            <div class="stat-value">{{userPosts}}</div>
                            <div class="stat-label">Publications</div>
                        </div>
                    </div>
                </div>
                <hr style="border: 1px solid lightgray;">
                
                <aside>
                    <a class="menu-item" routerLink="feed" routerLinkActive="active">
                        <span><mat-icon>home</mat-icon></span>
                        <h3>{{ 'NAV.HOME' | translate }}</h3>
                    </a>
                    <a class="menu-item" routerLink="videos" routerLinkActive="active">
                        <div class="icon-container">
                            <span><mat-icon>video_library</mat-icon></span>
                        </div>
                        
                        <h3>{{ 'NAV.VIDEOS' | translate }}</h3>
                    </a>
                    <a class="menu-item" routerLink="messages" routerLinkActive="active">
                        <div class="icon-container">
                            <span><mat-icon>message</mat-icon></span>
                            <span class="notfy-counter" *ngIf="unreadMessagesCount > 0">{{unreadMessagesCount}}</span>
                        </div>
                        
                        <h3>{{ 'NAV.MESSAGES' | translate }}</h3>
                    </a>
                    <a class="menu-item" routerLink="niaga-ia" routerLinkActive="active">
                        <span><mat-icon>smart_toy</mat-icon></span>
                        <h3>Niaga IA</h3>
                    </a>
                    <a class="menu-item" routerLink="settings" routerLinkActive="active">
                        
                        <span><mat-icon>settings</mat-icon></span>
                        <h3>{{ 'NAV.SETTINGS' | translate }}</h3>
                    </a>
                </aside>
            </ng-container>
        </div>

        <!-- Contenu principal -->
        <div class="middle">
            <router-outlet></router-outlet>
        </div>
    </div>

    <!-- Navigation mobile -->
    <div class="bottom-nav" *ngIf="isMobileView && (bottomBarService.showBottomBar$ | async) && !isNiagaIAView">
        <a class="menu-item" routerLink="feed" routerLinkActive="active">
            <span><mat-icon>home</mat-icon></span>
            <span>{{ 'NAV.HOME' | translate }}</span>
        </a>
        <a class="menu-item" routerLink="videos" routerLinkActive="active">
            <span><mat-icon>video_library</mat-icon></span>
            <span>{{ 'NAV.VIDEOS' | translate }}</span>
        </a>
        <a class="menu-item" routerLink="messages" routerLinkActive="active">
            <div class="icon-container">
                <span><mat-icon>message</mat-icon></span>
                <span class="notfy-counter" *ngIf="unreadMessagesCount > 0">{{unreadMessagesCount}}</span>
            </div>
            <span>{{ 'NAV.MESSAGES' | translate }}</span>
        </a>
        <a class="menu-item" routerLink="niaga-ia" routerLinkActive="active">
            <span><mat-icon>smart_toy</mat-icon></span>
            <span>IA</span>
        </a>
    </div>
</main>

<!-- Barre inférieure -->
<div class="bottom-bar" *ngIf="(bottomBarService.showBottomBar$ | async) && userHasProfile">
    <!-- ... reste du code ... -->
</div>